//Fix 69295 Cannot read properties of undefined (reading 'Container')
import { styled } from 'styled-components';

import { createResponsiveGeneralStyle } from '../../../utils';
import { Container } from '../Container';
import type { BoxProps } from './types';

const Wrapper = styled(Container)<BoxProps>`
  ${props => props.display !== undefined && createResponsiveGeneralStyle('display', props.display)};
  ${props => props.alignSelf !== undefined && createResponsiveGeneralStyle('align-self', props.alignSelf)};
`;

export const Box = ({
  style,
  className,
  position,
  boxSizing,
  display,
  width,
  minWidth,
  maxWidth,
  height,
  marginTop,
  marginRight,
  marginBottom,
  marginLeft,
  paddingTop,
  paddingRight,
  paddingBottom,
  paddingLeft,
  background,
  backgroundColor,
  flexGrow,
  flexShrink,
  flexBasis,
  initial,
  animate,
  variants,
  exit,
  transition,
  alignSelf,
  textAlign,
  border,
  borderRadius,
  boxShadow,
  role,
  children,
}: BoxProps) => (
  <Wrapper
    style={style}
    className={className}
    position={position}
    boxSizing={boxSizing}
    display={display}
    width={width}
    minWidth={minWidth}
    maxWidth={maxWidth}
    height={height}
    marginTop={marginTop}
    marginRight={marginRight}
    marginBottom={marginBottom}
    marginLeft={marginLeft}
    paddingTop={paddingTop}
    paddingRight={paddingRight}
    paddingBottom={paddingBottom}
    paddingLeft={paddingLeft}
    background={background}
    backgroundColor={backgroundColor}
    flexGrow={flexGrow}
    flexShrink={flexShrink}
    flexBasis={flexBasis}
    initial={initial}
    animate={animate}
    variants={variants}
    exit={exit}
    transition={transition}
    alignSelf={alignSelf}
    textAlign={textAlign}
    border={border}
    borderRadius={borderRadius}
    boxShadow={boxShadow}
    role={role}
  >
    {children}
  </Wrapper>
);
